<template>
  <RanksCheckGA4
    v-if="isViewGA4"
    :device="device"
    :id="id"
    :keyword="keyword"
    :keywords="keywords"
    :project="project"
    :status="status"
    :usage="usage"
    @openModalAddKeyword="openModalAddKeyword"
  />
  <RanksCheck
    v-else
    :device="device"
    :id="id"
    :keyword="keyword"
    :keywords="keywords"
    :project="project"
    :status="status"
    :usage="usage"
    @openModalAddKeyword="openModalAddKeyword"
  />
</template>

<script>
import RanksCheck from '@/components/siteImportantKeyword/RanksCheck';
import RanksCheckGA4 from '@/components/siteImportantKeywordGA4/RanksCheck';

export default {
  props: {
    gaType: {
      type: String,
      required: true
    },
    device: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    keyword: {
      type: String,
      required: false
    },
    keywords: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: false
    },
    usage: {
      type: Object,
      required: true
    }
  },
  components: {
    RanksCheck,
    RanksCheckGA4
  },
  computed: {
    isViewGA4() {
      return this.gaType === 'ga4';
    }
  },
  methods: {
    openModalAddKeyword() {
      this.$emit('openModalAddKeyword');
    }
  }
};
</script>
